import React from "react";
export const MediaContext = React.createContext({
  isYoutubePlaying: false,
  setPlayingVideo: () => {},
});
